import React from 'react';
import { ViewStyle, TextStyle } from 'react-native';
import styled from '@emotion/native';
import Button from '@/shared/components/Button';
import { red } from '@/shared/styles/colors';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import {
  SectionContainer,
  SectionHeader,
} from '@/shared/styles/styledComponents/settings';

interface Props {
  onDeleteAccount: () => void;
}

const DeleteAccountSection = ({ onDeleteAccount }: Props) => {
  const isDesktop = useIsDesktop();

  const deleteAccountButtonStyle: ViewStyle = {
    borderColor: red,
    borderWidth: 1,
    backgroundColor: 'transparent',
    width: isDesktop ? 'auto' : '100%',
    height: isDesktop ? 45 : 'auto',
    paddingHorizontal: isDesktop ? 40 : 0,
  };

  const deleteAccountLabelStyle: TextStyle = {
    color: red,
  };

  return (
    <SectionContainer>
      <SectionHeader>Delete Account:</SectionHeader>
      <DeleteAccountButtonContainer isDesktop={isDesktop}>
        <Button
          text="Confirm Deleting Account"
          onPress={onDeleteAccount}
          variant="secondary"
          customStyle={deleteAccountButtonStyle}
          customLabelStyle={deleteAccountLabelStyle}
        />
      </DeleteAccountButtonContainer>
    </SectionContainer>
  );
};

export default DeleteAccountSection;

const DeleteAccountButtonContainer = styled.View<{ isDesktop: boolean }>(
  ({ isDesktop }) => ({
    alignItems: isDesktop ? 'flex-start' : 'center',
    marginTop: 16,
  }),
);
